let module = angular.module('app.resources');

module.factory('Podcast', ($resource) => {
  'ngInject';
  return $resource(
    `${SYNDICATION_SERVICE_BASE_URL}/podcasts`,
    {},
    {
      getCategories: {
        method: 'GET',
        url: `${SYNDICATION_SERVICE_BASE_URL}/config/podcast-categories`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/podcast.js